import { API } from 'app/utils/client';
import { IOffer } from 'app/models';
import { CRUDService } from './api';

export class OfferService extends CRUDService<IOffer> { }

const instance = new OfferService(API, 'v1/offers');
export default instance;
